import React from 'react';
import {
  TextInputField,
  FormField,
  Button,
  SelectField,
} from 'evergreen-ui';

import { mutate } from 'swr';
import { toastNotification } from '../../shared/toastNotification';

import { Container } from 'react-grid-system';
import { useForm } from 'react-hook-form';
import { postInviteUserRoles } from '../../services/api/userRolesService';

const InviteUserForm = () => {
  const companyId = localStorage.getItem('companyId');
  const userId = localStorage.getItem('userId');

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
  } = useForm({});

  const inviteUser = () => {
    let statusResponse = '';
    let toastContent = '';
    const user = {
      adminId: userId,
      companyId: companyId,
      email: getValues('email'),
      userRole: getValues('role'),
      name: getValues('name'),
      lastName: getValues('lastName'),
    };
    postInviteUserRoles(user)
      .then((res) => {
        console.log('res post invited user: ', res);
        mutate('userRolesWithUserId');
        statusResponse = 'success';
        toastContent = 'Usuário convidado com sucesso.';
      })
      .catch((err) => {
        statusResponse = 'warning';
        console.log('post err', err);
        toastContent = err.response?.data?.message || 'Erro ao convidar usuário.';
      })
      .finally(() => {
        toastNotification(statusResponse, toastContent);
        mutate('banks');
      });
  };

  return (
    <form id='invite-form' onSubmit={handleSubmit(inviteUser)}>
      <FormField>
        <Container
          fluid={true}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '20px',
            width: '100%',
            maxWidth: '300px',
          }}
        >
          <TextInputField
            {...register('name')}
            label='Nome'
            id='invite-name'
            name='name'
            type='text'
            onChange={(e) => {
              setValue('name', e.target.value);
            }}
          />

          <TextInputField
            {...register('lastName')}
            label='Sobrenome'
            id='invite-lastName'
            name='lastName'
            type='text'
            onChange={(e) => {
              setValue('lastName', e.target.value);
            }}
          />

          <TextInputField
            {...register('email')}
            label='E-mail'
            id='invite-email'
            name='email'
            type='email'
            onChange={(e) => {
              setValue('email', e.target.value);
            }}
          />

          <SelectField
            {...register('role')}
            label='Nível de Acesso'
            defaultValue={undefined}
            onChange={(e) => setValue('role', e.target.value)}
          >
            <option value={undefined}></option>
            <option value='ADMIN'>ADMIN</option>
            <option value='ANALISTA'>ANALISTA</option>
            <option value='CONSULTOR'>CONSULTOR</option>
            <option value='LANÇADOR'>LANÇADOR</option>
          </SelectField>

          <Button
            type='submit'
            appearance='primary'
            intent='success'
            alignSelf='center'
          >
            Convidar
          </Button>
        </Container>
      </FormField>
    </form>
  );
};

export default InviteUserForm;
